import type { WorkbookPreviewSheet } from "../../lib/xlsxPreview.js";

/** Row and column indices are spreadsheet coordinates, including merged groups. */
export function workbookRowGroups(sheet: WorkbookPreviewSheet) {
  const vacationWarnings = new Set(sheet.warningRowIndexes ?? []);
  const groupSpans = new Map<number, number>();
  const groupNumbers = new Map<number, number>();
  if (sheet.groupByColumn !== undefined) {
    let rowIndex = 1;
    let groupNumber = 0;
    while (rowIndex < sheet.rows.length) {
      const groupValue =
        sheet.rows[rowIndex]?.[sheet.groupByColumn]?.trim() ?? "";
      if (!groupValue) {
        rowIndex += 1;
        continue;
      }
      let nextIndex = rowIndex + 1;
      while (
        nextIndex < sheet.rows.length &&
        sheet.rows[nextIndex]?.[sheet.groupByColumn]?.trim() === groupValue
      )
        nextIndex += 1;
      groupSpans.set(rowIndex, nextIndex - rowIndex);
      for (let row = rowIndex; row < nextIndex; row += 1)
        groupNumbers.set(row, groupNumber);
      groupNumber += 1;
      rowIndex = nextIndex;
    }
  }
  return { vacationWarnings, groupSpans, groupNumbers };
}
